<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Device Topup" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row mb-3">
								<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
										<i class='bx bx-chevrons-left'></i> Back
									</a>
								</div>
							</div>

							<div v-if="device" class="row mb-4">
								<div class="col-md-12">
									<div class="card bg-info text-white">
										<div class="card-body">
											<h5 class="card-title">Device Information</h5>
											<div class="row">
												<div class="col-md-3">
													<strong>IMEI:</strong> {{ device.imei }}
												</div>
												<div class="col-md-3">
													<strong>ICCID:</strong> {{ device.iccid }}
												</div>
												<div class="col-md-3">
													<strong>Vehicle No:</strong> {{ device.vehicle_no || 'N/A' }}
												</div>
												<div class="col-md-3">
													<strong>Dealer:</strong> {{ device.dealer_name || 'N/A' }}
												</div>
												<div class="col-md-3 mt-2" v-if="device.expirationtime">
													<strong>Expire On:</strong> {{ $filters.formatDateTime(device.expirationtime) }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<form @submit.prevent="updateRecharge" enctype="multipart/form-data">
								<div class="row">
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">No. of Days<span class="text-danger">*</span></label>
											<input class="form-control" type="number" min="1" step="1" placeholder="Enter number of days" v-model="rechargeData.no_of_days" :class="{ 'is-invalid': errors.no_of_days }"/>
											<div v-if="errors.no_of_days" class="invalid-feedback">{{ errors.no_of_days }}</div>
										</div>
									</div>

									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Amount<span class="text-danger">*</span></label>
											<input class="form-control" type="number" placeholder="Enter Amount" v-model="rechargeData.amount" :class="{ 'is-invalid': errors.amount }"/>
											<div v-if="errors.amount" class="invalid-feedback">{{ errors.amount }}</div>
										</div>
									</div>
								</div>

								<!-- Payment Type Section - Only show if payment is received -->
								<div class="row">
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Dealer<span class="text-danger">*</span></label>
											<div class="position-relative">
												<input
													class="form-control"
													type="text"
													placeholder="Search dealer..."
													v-model="dealerSearch"
													@input="searchDealer"
													@focus="showDealerSuggestions = true"
													@blur="hideDealerSuggestions"
													autocomplete="off"
													:class="{ 'is-invalid': errors.dealer_id }"
												/>
												<ul v-if="showDealerSuggestions && filteredDealers.length"
													class="list-group position-absolute w-100"
													style="z-index: 10; max-height: 200px; overflow-y: auto;">
													<li v-for="dealer in filteredDealers"
														:key="dealer.id"
														class="list-group-item list-group-item-action"
														@mousedown.prevent="selectDealer(dealer)">
														{{ dealer.first_name }}
													</li>
												</ul>
											</div>
											<div v-if="selectedDealer" class="mt-2">
												<small class="text-success">
													<i class="icofont icofont-check-circled me-1"></i>
													Selected: <strong>{{ selectedDealer.first_name }}</strong>
												</small>
											</div>
											<div v-if="device.dealer_name && !selectedDealer" class="mt-2">
												<small class="text-muted">Current: {{ device.dealer_name }}</small>
											</div>
											<div v-if="errors.dealer_id" class="invalid-feedback d-block">{{ errors.dealer_id }}</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Payment By<span class="text-danger">*</span></label>
											<select class="form-select" v-model="rechargeData.payment_by" @change="onPaymentByChange" :class="{ 'is-invalid': errors.payment_by }">
												<option value="">--Select Payment By--</option>
												<option value="1">Dealer</option>
												<option value="2">Customer</option>
											</select>
											<div v-if="errors.payment_by" class="invalid-feedback">{{ errors.payment_by }}</div>
										</div>
									</div>
									<div class="col-md-4" v-if="rechargeData.payment_by == '1'">
										<div class="form-group mb-3">
											<label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
											<div class="position-relative">
												<input
													class="form-control"
													type="text"
													placeholder="Search dealer..."
													v-model="paymentDealerSearch"
													@input="searchPaymentDealer"
													@focus="showPaymentDealerSuggestions = true"
													@blur="hidePaymentDealerSuggestions"
													autocomplete="off"
													:class="{ 'is-invalid': errors.payment_user_id }"
												/>
												<ul v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
													class="list-group position-absolute w-100"
													style="z-index: 10; max-height: 200px; overflow-y: auto;">
													<li v-for="dealer in filteredPaymentDealers"
														:key="dealer.id"
														class="list-group-item list-group-item-action"
														@mousedown.prevent="selectPaymentDealer(dealer)">
														{{ dealer.first_name }}
													</li>
												</ul>
											</div>
											<div v-if="selectedPaymentDealer" class="mt-2">
												<small class="text-success">
													<i class="icofont icofont-check-circled me-1"></i>
													Selected: <strong>{{ selectedPaymentDealer.first_name }}</strong>
												</small>
											</div>
											<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
										</div>
									</div>
									<div class="col-md-4" v-if="rechargeData.payment_by == '2'">
										<div class="form-group mb-3">
											<label class="control-label">Customer<span class="text-danger">*</span></label>
											<div class="position-relative">
												<input
													class="form-control"
													type="text"
													placeholder="Search by name or mobile..."
													v-model="paymentCustomerSearch"
													@input="searchPaymentCustomer"
													@focus="showPaymentCustomerSuggestions = true"
													@blur="hidePaymentCustomerSuggestions"
													autocomplete="off"
													:class="{ 'is-invalid': errors.payment_user_id }"
												/>
												<ul
													v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
													class="list-group position-absolute w-100"
													style="z-index: 10; max-height: 200px; overflow-y: auto;"
												>
													<li
														v-for="cust in filteredPaymentCustomers"
														:key="cust.id"
														class="list-group-item list-group-item-action"
														@mousedown.prevent="selectPaymentCustomer(cust)"
													>
														{{ cust.company_name }}
														<small v-if="cust.mobile" class="text-muted d-block">{{ cust.mobile }}</small>
													</li>
												</ul>
											</div>
											<div v-if="selectedPaymentCustomer" class="mt-2">
												<small class="text-success">
													<i class="icofont icofont-check-circled me-1"></i>
													Selected: <strong>{{ selectedPaymentCustomer.company_name }}</strong>
												</small>
											</div>
											<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
										</div>
									</div>
								</div>
								<div class="row" v-if="rechargeData.payment_user_id">
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Payment Status<span class="text-danger">*</span></label>
											<select class="form-select" v-model="rechargeData.payment_status" @change="onPaymentStatusChange" :class="{ 'is-invalid': errors.payment_status }">
												<option value="">--select--</option>
												<option value="1">Received</option>
												<option value="2">Not Received</option>
												<option value="4">Advance</option>
												<option value="5">Free Topup</option>
											</select>
											<div v-if="errors.payment_status" class="invalid-feedback">{{ errors.payment_status }}</div>
										</div>
									</div>
									<div class="col-md-4" v-if="rechargeData.payment_status == '2'">
										<div class="form-group mb-3">
											<label class="control-label d-block">&nbsp;</label>
											<div class="form-check mt-2">
												<input
													id="deduct_from_credit"
													class="form-check-input"
													type="checkbox"
													v-model="rechargeData.deduct_from_credit"
												/>
												<label class="form-check-label" for="deduct_from_credit">
													Deduct from advance amount
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-4" v-if="showUserCredit && rechargeData.payment_status == '2'">
										<div class="form-group mb-3">
											<label class="control-label">
												Amount from advance<span class="text-danger">*</span>
											</label>
											<input
												class="form-control"
												type="number"
												step="0.01"
												min="0"
												placeholder="Enter advance amount"
												v-model="rechargeData.amount_from_credit"
												:class="{ 'is-invalid': errors.amount_from_credit }"
											/>
											<div v-if="userCreditLoading" class="mt-2">
												<small class="text-success">Loading...</small>
											</div>
											<div
												v-else-if="userCredit && userCredit.credit_available_amount != null"
												class="mt-2"
											>
												<small class="text-success">Advance available: ₹{{ userCredit.credit_available_amount }}</small>
											</div>
											<div v-else class="mt-2">
												<small class="text-muted">-</small>
											</div>
											<div v-if="errors.amount_from_credit" class="invalid-feedback d-block">{{ errors.amount_from_credit }}</div>
											<div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
										</div>
									</div>
									<div class="col-md-4" v-else-if="showUserCredit && rechargeData.payment_status == '4'">
										<div class="form-group mb-3">
											<label class="control-label">
												Amount from credit<span class="text-danger">*</span>
											</label>
											<input
												class="form-control"
												type="number"
												step="0.01"
												min="0"
												placeholder="Enter credit amount"
												v-model="rechargeData.amount_from_credit"
												:class="{ 'is-invalid': errors.amount_from_credit }"
											/>
											<div v-if="userCreditLoading" class="mt-2">
												<small class="text-success">Loading...</small>
											</div>
											<div
												v-else-if="userCredit && userCredit.credit_available_amount != null"
												class="mt-2"
											>
												<small class="text-success">Advance available: ₹{{ userCredit.credit_available_amount }}</small>
											</div>
											<div v-else class="mt-2">
												<small class="text-muted">-</small>
											</div>
											<div v-if="errors.amount_from_credit" class="invalid-feedback d-block">{{ errors.amount_from_credit }}</div>
											<div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
										</div>
									</div>
								</div>

								<!-- Payment Type Section - Only show if payment is received -->
								<div class="row">
									<div class="col-md-4" v-if="rechargeData.payment_status == '1'">
										<div class="form-group mb-3">
											<label class="control-label">Payment Type<span class="text-danger">*</span></label>
											<select class="form-select" v-model="rechargeData.payment_type" @change="onPaymentTypeChange" :class="{ 'is-invalid': errors.payment_type }">
												<option value="">--Select Payment Type--</option>
												<option value="1">Cash</option>
												<option value="2">Online</option>
												<option value="3">Both</option>
												<option value="4">Credit</option>
											</select>
											<div v-if="errors.payment_type" class="invalid-feedback">{{ errors.payment_type }}</div>
										</div>
									</div>
									<div class="col-md-4" v-if="rechargeData.payment_status == '1'">
										<div class="form-group mb-3">
											<label class="control-label">Payment Date<span class="text-danger">*</span></label>
											<input
												class="form-control"
												type="date"
												v-model="rechargeData.payment_date"
												:class="{ 'is-invalid': errors.payment_date }"
											/>
											<div v-if="errors.payment_date" class="invalid-feedback">{{ errors.payment_date }}</div>
										</div>
									</div>
									<div class="col-md-4" v-if="rechargeData.payment_status == '1' && (rechargeData.payment_type == '2' || rechargeData.payment_type == '3')">
										<div class="form-group mb-3">
											<label class="control-label">Select Bank<span class="text-danger">*</span></label>
											<select
												class="form-select"
												v-model="rechargeData.bank_account_id"
												:class="{ 'is-invalid': errors.bank_account_id }"
											>
												<option value="">--Select Bank--</option>
												<option v-for="bank in banks" :key="bank.id" :value="bank.id">
													{{ bank.bank_name }} ({{ bank.account_number }})
												</option>
											</select>
											<div v-if="errors.bank_account_id" class="invalid-feedback">{{ errors.bank_account_id }}</div>
										</div>
									</div>
								</div>

								<!-- Online Payment Details -->
								<div class="row" v-if="rechargeData.payment_status == '1' && (rechargeData.payment_type == '2' || rechargeData.payment_type == '3')">
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Online Amount<span class="text-danger">*</span></label>
											<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="rechargeData.cash_online" :class="{ 'is-invalid': errors.cash_online }"/>
											<div v-if="errors.cash_online" class="invalid-feedback">{{ errors.cash_online }}</div>
										</div>
									</div>
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Payment ID<span class="text-danger">*</span></label>
											<input class="form-control" type="text" placeholder="Enter payment ID" v-model="rechargeData.payment_id" :class="{ 'is-invalid': errors.payment_id }"/>
											<div v-if="errors.payment_id" class="invalid-feedback">{{ errors.payment_id }}</div>
										</div>
									</div>
								</div>

								<!-- Cash Payment Details -->
								<div class="row" v-if="rechargeData.payment_status == '1' && (rechargeData.payment_type == '1' || rechargeData.payment_type == '3')">
									<div class="col-md-4">
										<div class="form-group mb-3">
											<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
											<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="rechargeData.cash_in_hand" :class="{ 'is-invalid': errors.cash_in_hand }"/>
											<div v-if="errors.cash_in_hand" class="invalid-feedback">{{ errors.cash_in_hand }}</div>
										</div>
									</div>
								</div>

								<!-- Payment Breakdown Display (informational only, no validation) -->
								<div class="row" v-if="paymentBreakdown">
									<div class="col-md-12">
										<div class="card border-light">
											<div class="card-body p-2">
												<div class="row text-center">
													<div class="col-md-3">
														<small class="text-muted">Total Amount</small>
														<div class="fw-bold">₹{{ paymentBreakdown.total }}</div>
													</div>
													<div class="col-md-3" v-if="rechargeData.payment_type === '2' || rechargeData.payment_type === '3'">
														<small class="text-muted">Online</small>
														<div class="fw-bold">₹{{ paymentBreakdown.online }}</div>
													</div>
													<div class="col-md-3" v-if="rechargeData.payment_type === '1' || rechargeData.payment_type === '3'">
														<small class="text-muted">Cash</small>
														<div class="fw-bold">₹{{ paymentBreakdown.cash }}</div>
													</div>
													<div class="col-md-3">
														<small class="text-muted">Status</small>
														<div class="fw-bold" :class="paymentBreakdown.statusClass">
															{{ paymentBreakdown.statusLabel }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row mt-3">
									<div class="col-sm-12">
										<button type="submit" class="btn btn-primary me-3" :disabled="loading">
											<span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
											{{ loading ? "Saving..." : button_title }}
										</button>
										<a href="#" @click.prevent="$router.go(-1)" class="btn btn-light">Cancel</a>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Device Topup",
	data() {
		return {
			device_id: null,
			device: {},
			loading: false,
			button_title: "Save",
			errors: {},
			rechargeData: {
				no_of_days: "",
				amount: 0,
				payment_status: "",
				payment_type: "",
				payment_date: "",
				payment_by: "",
				payment_user_id: "",
				amount_from_credit: "",
				bank_account_id: "",
				cash_online: "",
				cash_in_hand: "",
				payment_id: "",
				deduct_from_credit: false
			},
			userCredit: null,
			userCreditLoading: false,
			userCreditError: "",
			prevShowUserCredit: false,
			tc_device_id: "",
			dealers: [],
			dealerSearch: "",
			showDealerSuggestions: false,
			selectedDealer: null,
			// Payment Dealer (separate from Dealer)
			paymentDealerSearch: "",
			showPaymentDealerSuggestions: false,
			selectedPaymentDealer: null,
			// Payment Customer (when payment_by = customer)
			companies: [],
			paymentCustomerSearch: "",
			showPaymentCustomerSuggestions: false,
			selectedPaymentCustomer: null,
			// Banks
			banks: [],
		};
	},

	mounted() {
		this.device_id = this.$route.params.device_id;
		this.getToken();
		this.fetchDeviceDetails();
		this.fetchCompanies();
		this.fetchBankAccounts();
	},

	computed: {
		filteredDealers() {
			if (!this.dealerSearch.trim()) return this.dealers;
			const q = this.dealerSearch.toLowerCase();
			return this.dealers.filter(d => (d.first_name || "").toLowerCase().includes(q));
		},
		filteredPaymentDealers() {
			if (!this.paymentDealerSearch.trim()) return this.dealers;
			const q = this.paymentDealerSearch.toLowerCase();
			return this.dealers.filter(d => (d.first_name || "").toLowerCase().includes(q));
		},
		filteredPaymentCustomers() {
			if (!this.paymentCustomerSearch.trim()) return this.companies;
			const q = this.paymentCustomerSearch.toLowerCase().trim();
			return this.companies.filter((c) => {
				const name = (c.company_name || "").toLowerCase();
				const mobile = String(c.mobile || "").toLowerCase();
				return name.includes(q) || mobile.includes(q);
			});
		},
		paymentBreakdown() {
			if (!this.rechargeData.payment_type || this.rechargeData.payment_status != '1') return null;

			const total = parseFloat(this.rechargeData.amount) || 0;
			const online = parseFloat(this.rechargeData.cash_online) || 0;
			const cash = parseFloat(this.rechargeData.cash_in_hand) || 0;

			let paid = 0;
			if (this.rechargeData.payment_type === '2') {
				paid = online;
			} else if (this.rechargeData.payment_type === '1') {
				paid = cash;
			} else if (this.rechargeData.payment_type === '3') {
				paid = online + cash;
			} else {
				return null;
			}

			const eps = 0.01;
			const diff = paid - total;
			let statusLabel = 'Partial';
			let statusClass = 'text-warning';
			if (Math.abs(diff) < eps) {
				statusLabel = 'Full';
				statusClass = 'text-success';
			} else if (diff > eps) {
				statusLabel = 'Advance';
				statusClass = 'text-info';
			}

			if (this.rechargeData.payment_type === '2') {
				return { total, online, cash: 0, statusLabel, statusClass };
			}
			if (this.rechargeData.payment_type === '1') {
				return { total, online: 0, cash, statusLabel, statusClass };
			}
			return { total, online, cash, statusLabel, statusClass };
		},
		showUserCredit() {
			return (
				!!this.rechargeData.payment_user_id &&
				(
					this.rechargeData.payment_status === '4' ||
					(this.rechargeData.payment_status === '2' && !!this.rechargeData.deduct_from_credit)
				)
			);
		},
	},

	watch: {
		"rechargeData.payment_user_id": "maybeFetchUserCredit",
		"rechargeData.payment_status": "maybeFetchUserCredit",
		"rechargeData.deduct_from_credit": "maybeFetchUserCredit",
	},
	
	methods: {
		getSelectedUserId(entity) {
			return entity && entity.user_id ? entity.user_id : "";
		},

		todayIsoDate() {
			return new Date().toISOString().slice(0, 10);
		},

		/** Backend may return message as a string or a validation map like { field: ["msg"] }. */
		extractMessage(message) {
			if (!message) return "";
			if (typeof message === "string") return message;
			if (Array.isArray(message)) return String(message[0] ?? "");
			if (typeof message === "object") {
				const first = Object.values(message)[0];
				if (Array.isArray(first)) return String(first[0] ?? "");
				return String(first ?? "");
			}
			return String(message);
		},

		applyFieldErrors(source) {
			if (!source || typeof source !== "object" || Array.isArray(source)) return;
			Object.keys(source).forEach((k) => {
				const v = source[k];
				this.errors[k] = Array.isArray(v) ? v[0] : v;
			});
		},

		handleApiError(errorOrResponse) {
			const data = errorOrResponse?.response?.data ?? errorOrResponse?.data ?? errorOrResponse;
			const fieldErrors = data?.errors;
			const message = data?.message;

			if (fieldErrors && typeof fieldErrors === "object" && !Array.isArray(fieldErrors)) {
				this.applyFieldErrors(fieldErrors);
			}
			if (message && typeof message === "object" && !Array.isArray(message)) {
				this.applyFieldErrors(message);
			}

			return this.extractMessage(message) || this.extractMessage(fieldErrors) || "Something went wrong while saving topup";
		},

		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
						
				if(airotrack_staff.token) {

					this.token = airotrack_staff.token;
					this.user = airotrack_staff;

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		async fetchDeviceDetails() {
			try {
				this.loading = true;
				const response = await this.$axios.get(`/staffs/deviceDetail`, {
					params: { device_id: this.device_id },
					headers: { Authorization: `Bearer ${this.token}` },
				});

				if (response.data.status === "true") {
					this.device = response.data.data.device_details;
					this.rechargeData.no_of_days = "";
					this.rechargeData.amount = 0;
					this.rechargeData.payment_status = this.device.payment_status || "";
					this.rechargeData.payment_date = String(this.rechargeData.payment_status) === "1"
						? (this.device.payment_date ? String(this.device.payment_date).slice(0, 10) : this.todayIsoDate())
						: "";
					this.rechargeData.payment_type = this.device.payment_type || "";
					this.rechargeData.cash_online = this.device.cash_online || "";
					this.rechargeData.cash_in_hand = this.device.cash_in_hand || "";
					this.rechargeData.payment_id = this.device.payment_id || "";
					this.tc_device_id = this.device.tc_device_id || "";
					// Fetch dealers and set current dealer as default
					this.fetchDealers().then(() => {
						if (this.device.dealer_id) {
							const dealer = this.dealers.find(d => d.id == this.device.dealer_id);
							if (dealer) {
								this.selectedDealer = dealer;
								this.dealerSearch = dealer.first_name;
								// Default payment dealer = current dealer_id (separate from the Dealer field)
								this.selectedPaymentDealer = dealer;
								this.paymentDealerSearch = dealer.first_name;
								this.rechargeData.payment_by = this.rechargeData.payment_by || '1'; // default: dealer
								this.rechargeData.payment_user_id = this.getSelectedUserId(dealer);
							} else {
								this.dealerSearch = this.device.dealer_name || "";
							}
						} else if (this.device.dealer_name) {
							this.dealerSearch = this.device.dealer_name;
						}
					});
				} else {
					this.$swal("Error", response.data.message || "Failed to fetch device details", "error");
					this.$router.go(-1);
				}
			} catch (error) {
				console.error("Fetch error:", error);
				this.$swal("Error", "Failed to fetch device details", "error");
			} finally {
				this.loading = false;
			}
		},

		onPaymentStatusChange() {
			// Reset payment fields when payment status changes
			if (this.rechargeData.payment_status !== '1') {
				this.rechargeData.payment_type = "";
				this.rechargeData.payment_date = "";
				this.rechargeData.cash_online = "";
				this.rechargeData.cash_in_hand = "";
				this.rechargeData.payment_id = "";
				this.rechargeData.bank_account_id = "";
			} else {
				this.rechargeData.payment_date = this.todayIsoDate();
			}
			if (this.rechargeData.payment_status !== '2') {
				this.rechargeData.deduct_from_credit = false;
			}

			const shouldUseCredit = (
				this.rechargeData.payment_status === '4' ||
				(this.rechargeData.payment_status === '2' && !!this.rechargeData.deduct_from_credit)
			);
			if (!shouldUseCredit) {
				this.rechargeData.amount_from_credit = "";
			}
		},

		async maybeFetchUserCredit() {
			const nowVisible = this.showUserCredit;
			const wasVisible = this.prevShowUserCredit;

			if (!nowVisible) {
				this.userCredit = null;
				this.userCreditError = "";
				this.userCreditLoading = false;
				this.rechargeData.amount_from_credit = "";
				this.prevShowUserCredit = nowVisible;
				return;
			}
			if (!this.rechargeData.payment_user_id) return;

			// When credit section becomes visible for the first time,
			// default `amount_from_credit` with the main `amount`.
			if (!wasVisible) {
				this.rechargeData.amount_from_credit = this.rechargeData.amount || "";
				this.errors.amount_from_credit = "";
			}

			await this.fetchUserCredit();
			this.prevShowUserCredit = nowVisible;
		},

		async fetchUserCredit() {
			try {
				this.getToken();
				this.userCreditLoading = true;
				this.userCreditError = "";

				const response = await this.$axios.get("/staffs/getUserCredit", {
					params: { user_id: this.rechargeData.payment_user_id },
					headers: { Authorization: `Bearer ${this.token}` },
				});

				const ok = response.data?.status === true || response.data?.status === "true";
				if (!ok) {
					this.userCredit = null;
					this.userCreditError = response.data?.message || "Failed to fetch credit balance";
					return;
				}

				this.userCredit = response.data?.data?.user_credit || null;
			} catch (e) {
				this.userCredit = null;
				this.userCreditError = e?.response?.data?.message || "Failed to fetch credit balance";
			} finally {
				this.userCreditLoading = false;
			}
		},

		onPaymentByChange() {
			// Reset payment user selection when switching between Dealer/Customer
			this.rechargeData.payment_user_id = "";
			this.rechargeData.payment_status = "";
			this.rechargeData.payment_date = "";
			this.rechargeData.deduct_from_credit = false;
			this.rechargeData.amount_from_credit = "";
			this.errors.payment_user_id = "";

			if (this.rechargeData.payment_by === '1') {
				// Dealer
				this.selectedPaymentCustomer = null;
				this.paymentCustomerSearch = "";

				// Default payment dealer = current Dealer selection
				if (!this.selectedPaymentDealer && this.selectedDealer) {
					this.selectedPaymentDealer = this.selectedDealer;
					this.paymentDealerSearch = this.selectedDealer.first_name;
				}

				if (this.selectedPaymentDealer) {
					this.rechargeData.payment_user_id = this.getSelectedUserId(this.selectedPaymentDealer);
				}
			} else if (this.rechargeData.payment_by === '2') {
				// Customer
				this.selectedPaymentDealer = null;
				this.paymentDealerSearch = "";
				this.selectedPaymentCustomer = null;
				this.paymentCustomerSearch = "";
			}
		},

		onPaymentTypeChange() {
			// Reset payment amounts when payment type changes
			if (this.rechargeData.payment_type === '2') { // Online
				this.rechargeData.cash_in_hand = '';
			} else if (this.rechargeData.payment_type === '1') { // Cash
				this.rechargeData.cash_online = '';
				this.rechargeData.payment_id = '';
			} else if (this.rechargeData.payment_type === '3') { // Both
				// Keep both fields available
			}

			// Clear bank selection when switching away from Online/Both
			if (!(this.rechargeData.payment_type === '2' || this.rechargeData.payment_type === '3')) {
				this.rechargeData.bank_account_id = '';
			}
		},

		fetchDealers() {
			this.getToken();
			return this.$axios
				.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.dealers = Array.isArray(data) ? data : (data.data || []);
					return this.dealers;
				})
				.catch((err) => {
					console.log(err);
					this.dealers = [];
					return [];
				});
		},
		searchDealer() {
			this.showDealerSuggestions = true;
		},
		hideDealerSuggestions() {
			setTimeout(() => { this.showDealerSuggestions = false; }, 200);
		},
		selectDealer(dealer) {
			this.selectedDealer = dealer;
			this.dealerSearch = dealer.first_name;
			this.showDealerSuggestions = false;
		},

		searchPaymentDealer() {
			this.showPaymentDealerSuggestions = true;
		},
		hidePaymentDealerSuggestions() {
			setTimeout(() => { this.showPaymentDealerSuggestions = false; }, 200);
		},
		selectPaymentDealer(dealer) {
			this.selectedPaymentDealer = dealer;
			this.paymentDealerSearch = dealer.first_name;
			this.showPaymentDealerSuggestions = false;
			this.rechargeData.payment_user_id = this.getSelectedUserId(dealer);
			this.errors.payment_user_id = "";
		},

		fetchCompanies() {
			this.getToken();
			return this.$axios
				.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.companies = Array.isArray(data) ? data : (data.data || []);
				})
				.catch((err) => {
					console.log(err);
					this.companies = [];
				});
		},

		searchPaymentCustomer() {
			this.showPaymentCustomerSuggestions = true;
		},
		hidePaymentCustomerSuggestions() {
			setTimeout(() => { this.showPaymentCustomerSuggestions = false; }, 200);
		},
		selectPaymentCustomer(cust) {
			this.selectedPaymentCustomer = cust;
			this.paymentCustomerSearch = cust.company_name;
			this.showPaymentCustomerSuggestions = false;
			this.rechargeData.payment_user_id = this.getSelectedUserId(cust);
			this.errors.payment_user_id = "";
		},

		fetchBankAccounts() {
			this.getToken();
			return this.$axios
				.get("/staffs/bankAccounts", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.banks = Array.isArray(data) ? data : (data.data || []);
				})
				.catch((err) => {
					console.log(err);
					this.banks = [];
				});
		},

		async updateRecharge() {
			this.loading = true;
			this.errors = {};

			// Basic Validation
			const daysVal = parseInt(this.rechargeData.no_of_days, 10);
			if (!this.rechargeData.no_of_days || isNaN(daysVal) || daysVal < 1) {
				this.errors.no_of_days = "No. of days is required";
			}
			// Allow 0 for topup (e.g. Free Topup); only reject truly empty values
			const amountVal = this.rechargeData.amount;
			const amountEmpty =
				amountVal === "" ||
				amountVal === null ||
				amountVal === undefined ||
				(typeof amountVal === "string" && amountVal.trim() === "");
			if (amountEmpty) {
				this.errors.amount = "Amount is required";
			}
			if (!this.rechargeData.payment_status) {
				this.errors.payment_status = "Payment status is required";
			}
			if (!this.selectedDealer) {
				this.errors.dealer_id = "Please select a dealer";
			}

			// Payment Type Validation (required if payment_status is 1)
			if (this.rechargeData.payment_status === '1') {
				if (!this.rechargeData.payment_by) {
					this.errors.payment_by = "Payment by is required";
				}
				if (!this.rechargeData.payment_user_id) {
					this.errors.payment_user_id = "Payment user is required";
				}
				if (!this.rechargeData.payment_date) {
					this.errors.payment_date = "Payment date is required";
				}

				if (!this.rechargeData.payment_type) {
					this.errors.payment_type = "Payment type is required when payment is received";
				} else {
					if (this.rechargeData.payment_type === '2') { // Online
						if (!this.rechargeData.cash_online || parseFloat(this.rechargeData.cash_online) <= 0) {
							this.errors.cash_online = "Online amount is required";
						}
						if (!this.rechargeData.bank_account_id) {
							this.errors.bank_account_id = "Bank account is required for online payment";
						}
						if (!this.rechargeData.payment_id) {
							this.errors.payment_id = "Payment ID is required for online payment";
						}
					} else if (this.rechargeData.payment_type === '1') { // Cash
						if (!this.rechargeData.cash_in_hand || parseFloat(this.rechargeData.cash_in_hand) <= 0) {
							this.errors.cash_in_hand = "Cash amount is required";
						}
					} else if (this.rechargeData.payment_type === '3') { // Both
						if (!this.rechargeData.cash_online || parseFloat(this.rechargeData.cash_online) <= 0) {
							this.errors.cash_online = "Online amount is required";
						}
						if (!this.rechargeData.cash_in_hand || parseFloat(this.rechargeData.cash_in_hand) <= 0) {
							this.errors.cash_in_hand = "Cash amount is required";
						}
						if (!this.rechargeData.bank_account_id) {
							this.errors.bank_account_id = "Bank account is required for online/both payment";
						}
						if (!this.rechargeData.payment_id) {
							this.errors.payment_id = "Payment ID is required for online payment";
						}
					}
				}
			}

			// Credit Amount Validation (required if using credit)
			if (this.showUserCredit) {
				const creditAmt = parseFloat(this.rechargeData.amount_from_credit);
				if (!this.rechargeData.amount_from_credit || isNaN(creditAmt) || creditAmt <= 0) {
					this.errors.amount_from_credit = "Amount from credit is required";
				} else {
					// Validate against available credit if API response already loaded
					if (this.userCredit && this.userCredit.credit_available_amount != null) {
						const available = parseFloat(this.userCredit.credit_available_amount);
						if (!isNaN(available) && creditAmt > available) {
							this.errors.amount_from_credit = "Amount from credit cannot exceed available credit";
						}
					}
					// Also validate against work amount if provided
					if (this.rechargeData.amount) {
						const totalAmt = parseFloat(this.rechargeData.amount);
						if (!isNaN(totalAmt) && creditAmt > totalAmt) {
							this.errors.amount_from_credit = "Amount from credit cannot exceed work amount";
						}
					}
				}
			}

			if (Object.keys(this.errors).length > 0) {
				this.loading = false;
				const firstError = Object.values(this.errors)[0];
				this.$swal("Error", firstError || "Please fix the highlighted fields", "error");
				return;
			}

			try {
				const payload = {
					device_id: this.tc_device_id,
					dealer_id: this.selectedDealer ? this.selectedDealer.id : null,
					no_of_days: parseInt(this.rechargeData.no_of_days, 10),
					amount: this.rechargeData.amount,
					payment_status: this.rechargeData.payment_status,
					deduct_from_credit: this.rechargeData.payment_status === '4'
						? 1
						: (this.rechargeData.payment_status === '2' ? (this.rechargeData.deduct_from_credit ? 1 : 2) : 2),
					bank_account_id: "",
				};

				// Always pass selected payment user details when available
				if (this.rechargeData.payment_by && this.rechargeData.payment_user_id) {
					payload.payment_user_type = this.rechargeData.payment_by;
					payload.payment_user_id = this.rechargeData.payment_user_id;
				}

				// Add payment type fields only if payment is received
				if (this.rechargeData.payment_status === '1') {
					payload.payment_type = this.rechargeData.payment_type;
					payload.payment_date = this.rechargeData.payment_date;
					if (this.rechargeData.payment_type === '2' || this.rechargeData.payment_type === '3') {
						payload.bank_account_id = this.rechargeData.bank_account_id;
						payload.cash_online = this.rechargeData.cash_online;
						payload.payment_id = this.rechargeData.payment_id;
					}
					if (this.rechargeData.payment_type === '1' || this.rechargeData.payment_type === '3') {
						payload.cash_in_hand = this.rechargeData.cash_in_hand;
					}
				}

				// Credit usage amount (only when using credit)
				payload.amount_from_credit = this.showUserCredit
					? (this.rechargeData.amount_from_credit ? parseFloat(this.rechargeData.amount_from_credit) : 0)
					: 0;

				const response = await this.$axios.post(
					"/staffs/topupRequest",
					payload,
					{
						headers: {
							Authorization: `Bearer ${this.token}`,
						},
					}
				);

				if (response.data.status === true || response.data.status === "true") {
					this.$swal({
						title: "Success",
						text: this.extractMessage(response.data.message) || "Device topup saved successfully",
						icon: "success",
						timer: 1500,
						showConfirmButton: false,
					});
					this.$router.go(-1);
				} else {
					this.$swal("Error", this.handleApiError(response), "error");
				}

			} catch (error) {
				console.error("API Error:", error);
				this.$swal("Error", this.handleApiError(error), "error");
			} finally {
				this.loading = false;
			}
		}

	}
};
</script>
